<div class="modal-header">
  <h3>Select Clients</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col">
      <label class="form-label" requiredAsterisk>Client(s)</label>
      <app-multi-select
        [Items]="CompaniesMap"
        (selectedItemsChange)="companyMapChange($event)"
      ></app-multi-select>
    </div>

    @if (SelectStates) {
      <div class="col-6">
        <label class="form-label">State</label>
        <app-multi-select
          [Items]="SubNationalDivisionsMap"
          (selectedItemsChange)="subNationalDivisionMapChange($event)"
        ></app-multi-select>
      </div>
    }
  </div>
</div>
<div class="modal-footer">
  <div class="col">
    <button type="button" class="btn btn-danger h-100" (click)="close()">
      Close
    </button>
  </div>

  <div class="col">
    <button type="button" class="btn btn-primary h-100" (click)="submit()">
      Continue
    </button>
  </div>
</div>
